const formatAmount = (value, useMinimumFractionDigits = true, showMonetarySymbol = true) => {
    const numberValue = Number(value);
    if (Number.isNaN(numberValue)) {
        return '€0.00';
    }
    return `${showMonetarySymbol ? '€' : ''}${new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: useMinimumFractionDigits ? 2 : 0,
    }).format(numberValue)}`;
};
export default formatAmount;
